import React, {useEffect, useMemo} from "react";
import "./App.css";
import { createBrowserRouter, Navigate, RouterProvider } from "react-router-dom";
import Root from "./pages/Root";
import ErrorPage from "./pages/error";
import { Header } from "./components/header";
import { Footer } from "./components/footer";
import {
  ApplicationCOOStep1,
  StartApplicationCOO,
  ApplicationCOOStep2,
  ApplicationCOOStep3,
  ApplicationCOOStep4,
  ApplicationCOOStep5,
  StagesProcess,
} from "./pages/application-coo";
import { useAppSelector, useAppDispatch } from "./redux/hook";
import StageCPaymentLanding from "./pages/application-coo-stage-c/stage-c-payment-landing";
import { ConsentPage } from "./pages/application-coo-stage-b";
import OthersReview from "./pages/application-coo-stage-b/others-review";
import StageCSuccessful from "./pages/application-coo-stage-c/stage-c-success";
import StageCUnsuccessful from "./pages/application-coo-stage-c/stage-c-unsuccessful";
import StageDApplicationReview from "./pages/application-coo-stage-d/step-1/landing";
import { keys, reduce } from "lodash";
import PropertySelection from "./pages/application-coo/property-selection";
import config from "./config";
import StageDFinancialReview from "./pages/application-coo-stage-d/step-4/landing";
import StageDInPrincipleApproval from "./pages/application-coo-stage-d/step-2/landing";
import StageEPage from "./pages/application-coo-stage-e";
import StageAViewApplication from "./pages/application-coo/view-application";
import StageASuccess from "./pages/application-coo/application-success";
import CancelApplicationPayment from "./pages/application-coo/cancel-application-payment";
import ApplicationCancelled from "./pages/application-coo/application-cancelled";
import Page404 from "./pages/404";
import Page500 from "./pages/500";
import PendingItemsPage from "./pages/application-coo/pending-items";
import Auth from "./pages/auth";
import NormalApiLogin from "./pages/authentication/normal-login";
import { setBackTriggered } from "./redux/slices/back-triggered-slice";
import EstimateFees from "./pages/estimate-fees";
import Logout from "./pages/logout";
import LogoutPublic from "./pages/logout-public";

function App() {
  const BASE_PATH = "/transfer";

  const isAuthenticated = useAppSelector( (state) => state.auth.AuthenticationSlice.isAuthenticated);
  const completedStageA = useAppSelector(state => state.app.CompletedStepsSlice.stage_a);
  const successPageStageA = useAppSelector(state => state.app.CompletedStepsSlice.step_a_success);
  const startCooApplication = useAppSelector(state => state.route.RouteManagementSlice.startCooApplication);
  const startAddressSelection = useAppSelector(state => state.route.RouteManagementSlice.startAddressSelection);
  const startStageD = useAppSelector(state => state.route.RouteManagementSlice.startStageD);
  const startStageE = useAppSelector(state => state.route.RouteManagementSlice.startStageE);
  const applicationStatus = useAppSelector(state => state.app.ApplicationStageDSlice.application_status);
  const AppDispatch = useAppDispatch();
  if (process.env.NODE_ENV !== "production" || document.location.origin === "https://services3-dev.hdb.gov.sg" || document.location.origin === "https://services3-stg.hdb.gov.sg") {
    document.title = `${document.title} - ${config.version}`;

    const wogaa_script = document.createElement('script');
    wogaa_script.setAttribute('src','https://assets.wogaa.sg/scripts/wogaa.js');
    document.head.appendChild(wogaa_script);
  }
  else{
    const wogaa_script = document.createElement('script');
    wogaa_script.setAttribute('src','https://assets.wogaa.sg/scripts/wogaa.js');
    document.head.appendChild(wogaa_script);
  }

  const publicRouter = createBrowserRouter(
    [
      {
        path: "/",
        element: <NormalApiLogin />,
        errorElement: <Navigate to="/" />,
      },
      {
        path: "/logout",
        element: <LogoutPublic />,
        errorElement: <Page404 />,
      },
      {
        path: "/404",
        element: <Page404 />,
        errorElement: <ErrorPage />,
      },
      {
        path: "/500",
        element: <Page500 />,
        errorElement: <ErrorPage />,
      },
      ...(config.showEstimateFees
        ? [
            {
              path: "/estimate-fees-from-eservice",
              element: <EstimateFees fromTransfer={false} />,
              errorElement: <Page404 />,
            },
          ]
        : []),
    ],
    {
      basename: BASE_PATH,
    }
  );

  const stageARouters = useMemo(()=> [
    {
      path: "/application-coo/stage-a/declaration",
      element: <StartApplicationCOO />,
    },
    {
      path: "/application-coo/stage-a/eligibility",
      element: <ApplicationCOOStep1 />,
    },
    {
      path: "/application-coo/stage-a/financing",
      element: <ApplicationCOOStep2 />,
    },
    {
      path: "/application-coo/stage-a/conveyancing",
      element: <ApplicationCOOStep3 />,
    },
    {
      path: "/application-coo/stage-a/upload-documents",
      element: <ApplicationCOOStep4 />,
    },
    {
      path: "/application-coo/stage-a/summary",
      element: <ApplicationCOOStep5 />,
    },
    {
      path: "/application-coo/stage-a/view-application",
      element: <StageAViewApplication />
    }
  ],[]);


  const stageACompleted = useMemo(()=> [
    {
      path: "/application-coo/stage-a/declaration",
      element: <StartApplicationCOO />,
    },
    {
      path: "/application-coo/stage-a/consent",
      element: <ConsentPage stage="A" />,
    },

  ],[]);

  const stageASuccess = useMemo(()=>[
    {
      path: "/application-coo/stage-a/success",
      element: <StageASuccess />
    }
  ],[])


  const manageStageARouters = useMemo(()=>{
    let stageA:any = completedStageA

    const debugRoute = true;
    const allFieldsTrue = reduce(keys(stageA),(result, key) => result && stageA[key.toString()],true); //When step

    let routes:any[] = [];
    if(!startCooApplication){
      return [];
    }
    if(!allFieldsTrue || debugRoute){
      const processedRouters = !applicationStatus || applicationStatus === 'SAVE_DRAFT' ? stageARouters : stageARouters.filter(item => item.path === "/application-coo/stage-a/view-application");
      routes = [...routes, ...processedRouters];
    }
    if(allFieldsTrue || debugRoute){
      routes = [...routes, ...stageACompleted];
    }
    if(successPageStageA || debugRoute){
      routes = [...routes, ...stageASuccess];
    }
    return routes
  }, [completedStageA, startCooApplication, successPageStageA, stageARouters, stageACompleted, stageASuccess, applicationStatus])


  const manageAddressSelectionRoute = useMemo(()=>{
    if(!startAddressSelection){
      return [];
    }
    return [
      {
        path: "/application-coo/property-selection",
        element: <PropertySelection />,
      }
    ]

  },[ startAddressSelection ])





  const manageStateDRouters = useMemo(()=>{
    //Open stage D route when at Stage E
    console.log("DEBUG startStageD || startStageE",startStageD, startStageE);
    if(startStageD || startStageE){
      return [
        {
          path: "/application-coo/stage-d/hdb-review",
          element: <StageDApplicationReview />,
        },
        {
          path: "/application-coo/stage-d/in-principle-approval",
          element: <StageDInPrincipleApproval />,
        },
        {
          path: "/application-coo/stage-d/review-financial-plan",
          element: <StageDFinancialReview />,
        }
      ]
    }
    return [];

    // //BELOW ARE ROUTES WITH GUARDING
    // const routes = [];

    // if(application_status === "STAGE_D_HDB_REVIEW" || application_status === "STAGE_D_PENDING_APPLICANT"){
    //   routes.push(
    //     {
    //       path: "/application-coo/stage-d/hdb-review",
    //       element: <StageDApplicationReview />,
    //     }
    //   );
    // }
    // if(application_status === "STAGE_D_IN_PRINCIPLE_APPROVAL"){
    //   routes.push(
    //     {
    //       path: "/application-coo/stage-d/in-principle-approval",
    //       element: <StageDInPrincipleApproval />,
    //     }
    //   );
    // }
    // if(application_status === "STAGE_D_REVIEW_FINANCIAL_PLAN" || is_financial_plan_ready){
    //   routes.push(
    //     {
    //       path: "/application-coo/stage-d/review-financial-plan",
    //       element: <StageDFinancialReview />,
    //     }
    //   );
    // }
    // return routes;

  },[startStageD, startStageE])

  const manageStateERouters = useMemo(()=>{
    if(!startStageE){
      return [];
    }

    return [
      {
        path: "/application-coo/stage-e/prepare-for-completion",
        element: <StageEPage />,
      },
    ];


    // const routes = [];

    // if(application_status === "PREPARE_FOR_COMPLETION"){
    //   routes.push(
    //     {
    //       path: "/application-coo/stage-e/prepare-for-completion",
    //       element: <StageEPage />,
    //     },
    //   );
    // }
    // return routes;

  },[startStageE, applicationStatus])


  const router = [
    {
      path: "/",
      element: <Auth />,
      errorElement: <Page404 />,
    },
    {
      path: "/logout",
      element: <Logout />,
      errorElement: <Page404 />,
    },
    {
      path: "/dashboard",
      element: <Root />,
      errorElement: <Page404 />,
    },
    {
      path: "/error",
      element: <Page404 />,
      errorElement: <Page404 />,
    },
    {
      path: "/application-coo",
      element: <StagesProcess />,
    },
    {
      path: "/application-coo/cancel-application-payment",
      element: <CancelApplicationPayment />,
    },
    {
      path: "/application-coo/stage-b/consent",
      element: <ConsentPage stage="B" />,
    },
    {
      path: "/application-coo/stage-b/review",
      element: <OthersReview />,
    },
    {
      path: "/application-coo/stage-c/payment",
      element: <StageCPaymentLanding />,
    },
    {
      path: "/application-coo/stage-c/payment/successful",
      element: <StageCSuccessful />,
    },
    {
      path: "/application-coo/stage-c/payment/unsuccessful",
      element: <StageCUnsuccessful />,
    },
    {
      path: "/application-coo/application-cancelled",
      element: <ApplicationCancelled />,
    },
    {
      path: "/application-coo/pending-items",
      element: <PendingItemsPage />,
    },
    {
      path: "/404",
      element: <Page404 />,
      errorElement: <Page404 />,
    },
    {
      path: "/500",
      element: <Page500 />,
      errorElement: <Page500 />,
    },
    ...(config.showEstimateFees
      ? [
          {
            path: "/estimate-fees",
            element: <EstimateFees fromTransfer={true} />,
            errorElement: <Page404 />,
          },
          {
            path: "/estimate-fees-from-eservice",
            element: <EstimateFees fromTransfer={false} />,
            errorElement: <Page404 />,
          },
        ]
      : []),
  ];
  const authRouter = createBrowserRouter(
    [
      ...router,
      ...manageStageARouters,
      ...manageAddressSelectionRoute,
      ...manageStateDRouters,
      ...manageStateERouters,
    ],
    {
      basename: BASE_PATH,
    }
  );

  // only for dev
  // const path = window.location.pathname;
  // useEffect(() => {
  //   let updatingPath = path === "/transfer" ? "/" : path.replace("/transfer" , "");
  //   if(authRouter.routes.every(item => item.path !== updatingPath)){
  //       window.location.href = "/transfer/404";
  //   }
  //   if (path === '/') {
  //     window.location.href = '/transfer';
  //   }

  //   AppDispatch(setLeavePageModalOpen(false));
  //   AppDispatch(setNavigatingValue(undefined));
  //   return () => {
  //      AppDispatch(setPreviousPageUrl(updatingPath));
  //   }
  // }, [path]);
  useEffect(() => {
    const stageAApplicationRoutes: string[] = [
      "/application-coo/stage-a/eligibility",
      "/application-coo/stage-a/financing",
      "/application-coo/stage-a/conveyancing",
      "/application-coo/stage-a/upload-documents",
      "/application-coo/stage-a/summary",
    ];
    //if the user leave stage A application page, set back trigger to false
    //so that next time when enter application again, the back modal wont be triggered directly
    if(stageAApplicationRoutes.every(item => !window.location.href.includes(item))){
      AppDispatch(setBackTriggered(false));
      // AppDispatch(setApplicationId(undefined));
    }
  }, [window.location.href])
  return (
    <React.StrictMode>
      {process.env.NODE_ENV !== "production" && <script src={"https://assets.dcube.cloud/scripts/wogaa.js"} integrity="sha384-K2ZDgDMBKb84DUWnIO+fQWuJmIiazqdWGj7kOfODHXH2IecfjYw0LXuho3QE5Rg1" crossOrigin="anonymous"></script>}
      {process.env.NODE_ENV === "production" && <script src={"https://assets.wooga.sg/scripts/wogaa.js"}></script>}
      <Header />
      {!isAuthenticated && <RouterProvider router={publicRouter} />}
      {isAuthenticated && <RouterProvider router={authRouter} />}
      <Footer />
    </React.StrictMode>
  );
}

export default App;
